import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getDocumentApprovalAPI, updateDocumentApprovalAPI } from './api';
import {
  filterDocumentApproval,
  filterDocumentApprovalSuccess,
  filterDocumentApprovalFailure,
  updateDocumentApprovalSuccess,
  updateDocumentApprovalFailure,
  updateDocumentApproval,
} from './slice';

function* fetchDocumentApprovalSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getDocumentApprovalAPI, trimQueryData(payload));
    yield put(filterDocumentApprovalSuccess(response.data));
  } catch (error) {
    yield put(filterDocumentApprovalFailure());
  }
}

function* updateDocumentApprovalSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateDocumentApprovalAPI, payload);
    yield put(updateDocumentApprovalSuccess(response));
  } catch (error: any) {
    yield put(updateDocumentApprovalFailure({ message: error?.message }));
  }
}

function* watchDocumentApproval() {
  yield takeLatest(filterDocumentApproval, fetchDocumentApprovalSaga);
  yield takeLatest(updateDocumentApproval, updateDocumentApprovalSaga);
}

export default watchDocumentApproval;
